export const colors = ['#dd3663', '#9af139', '#1a90e5', '#f19729', '#a24cd4'];
